module.exports = __webpack_public_path__ + "img/dragon.77697697.svg";